export const COMPANY_NAME = "Prestige car rent";
export const COMPANY_OWNER = "Mijo Jović";
export const COMPANY_ADDRESS =
  "Ul. Ante Starčevića 32 (Poslovni prostor oznaka 26, nivo B)";
export const COMPANY_CITY = "Makarska";
export const COMPANY_COUNTRY = "Hrvatska";
export const COMPANY_OIB = "55559281940";
export const COMPANY_PHONE = "+385 99 5981 704";
export const COMPANY_EMAIL = "info@prestigecarrent.com";
